export default "__VITE_ASSET__Dgy$aOfS__"